import {
  MdOutlineAddBox,
  MdChatBubbleOutline,
  MdSmartphone, MdPhoneDisabled, MdPhoneAndroid
} from 'react-icons/md'

import Stoploss100 from '../../../../assets/svgs/stoploss-100.svg?component'
import Stoploss80 from '../../../../assets/svgs/stoploss-80.svg?component'
import TribalIcon from '../../../../assets/svgs/trabal.svg?component'
import { useAppDispatch, useAppSelector } from '../../../../store'
import * as sidebarActions from '../../../../store/modules'
import { ChatType } from '../../../chats'
import { SidebarOptionKind } from '../../../layout/sidebar/types'

import AllergyModal from './allergyModal'
const specThreshold1 = 50
const specThreshold2 = 100

const Section5 = ({
  clientName,
  patientId,
  hospitalized,
  isMobileEnrolled,
                    isMemberPortalMobileEnrolled,
  specPercentage,
  hasAllergies,
  hasDNR,
  hasAdvancedDirective,
  hasPOLST,
  doNotCall
}) => {
  const attributes = useAppSelector((state) => {
    return state.globalVars?.clients?.find((c) => c.clientName === clientName)?.attributes
  })
  let dispatch = useAppDispatch()
  return (
    <div className='flex flex-row gap-3 self-start pt-4 justify-end pr-4 max-w-[13rem]'>
      <div className='flex flex-col gap-3 self-start'>
        <div className='flex flex-row gap-2 justify-end items-center'>
          {attributes?.includes('Tribal') && (
            <IconBox title='Tribal'>
              <TribalIcon
                width='16px'
                height='16px'
              />
            </IconBox>
          )}
          {doNotCall && (
            <IconBox title='Do not call'>
              <MdPhoneDisabled
                size='1.3rem'
                className='text-gray-600'
              />
            </IconBox>
          )}
          {isMobileEnrolled && (
            <IconBox title='Patient Enrolled to Mobile'>
              <MdSmartphone
                size='1.3rem'
                className='text-gray-600'
              />
            </IconBox>
          )}
          {isMemberPortalMobileEnrolled && (
              <IconBox title="Patient Enrolled to Member Portal Mobile">
                <MdPhoneAndroid
                    size="1.3rem"
                    className="text-blue-400"
                />
              </IconBox>
          )}
          {specPercentage && specPercentage.percentage >= specThreshold1 && (
            <div title={`Patient at ${specPercentage.percentage}% of spec\nSpec amount: $${specPercentage.amount}\nTotal paid: $${specPercentage.totalPaid}`}>
              {specPercentage.percentage < specThreshold2 && (
                <Stoploss80
                  width='20px'
                  height='20px'
                  viewBox='0 0 15 15'
                />
              )}
              {specPercentage.percentage >= specThreshold2 && (
                <Stoploss100
                  width='20px'
                  height='20px'
                  viewBox='0 0 15 15'
                />
              )}
            </div>
          )}
          {hospitalized && (
            <IconBox title='Hospitalized'>
              <MdOutlineAddBox
                size='1.4rem'
                className='text-gray-600'
              />
            </IconBox>
          )}
          <button
            type='button'
            data-test-id='chat-with-patient'
            onClick={() => {
              dispatch(sidebarActions.open(SidebarOptionKind.messages))
              dispatch(sidebarActions.selectTab(ChatType.Current))
            }}
            className='flex justify-center items-center cursor-pointer p-1 -m-1 text-blue-500 rounded-md transition-all hover:bg-blue-100 pointer'
            title='Chat with patient'
          >
            <IconBox>
              <MdChatBubbleOutline
                size='1.3rem'
                className='transition-colors'
                color='inherit'
              />
            </IconBox>
          </button>
        </div>
        <div className='flex flex-row gap-2 flex-wrap justify-end'>
          {hasAllergies && (
            <AllergyModal
              name='Allergy'
              patientId={patientId}
            />
          )}
          {hasDNR && (
            <div
              className='py-0.5 px-3 rounded bg-red-100 text-red-600 font-bold tracking-wide whitespace-nowrap'
              title='Patient ordered DNR'
            >
              DNR
            </div>
          )}
          {hasAdvancedDirective && (
            <div
              className='py-0.5 px-3 rounded bg-gray-100 text-gray-600 font-bold tracking-wide whitespace-nowrap'
              title='Patient has Advance Directives'
            >
              ADV DIR
            </div>
          )}
          {hasPOLST && (
            <div
              className='py-0.5 px-3 rounded bg-gray-100 text-gray-600 font-bold tracking-wide whitespace-nowrap'
              title='Patient has POLST'
            >
              POLST
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

function IconBox ({ children, title }) {
  return (
    <div
      title={title}
      className='w-6 h-6 flex justify-center items-center'
    >
      {children}
    </div>
  )
}

export default Section5
